export default {
  common: {
    cancel: "Annuler",
    add: "Ajouter",
    back: "Retour", 
    next: "Suivant", 
    submit: "Envoyer",
    saving: "Enregistrement…",
    saved: "Enregistré ✓",
  },

  menu: {
    backToDashboard: "Retour au tableau de bord",
    myObjects: "Mes hébergements",
    settings: "Paramètres",
    help: "Aide / Contact",
    logout: "Déconnexion",
    language: "Français",
  },

  contact: {
    title: "Contact",
    subtitle: "Comment pouvons-nous vous aider ?",
    messageLabel: "Votre message",
    send: "Envoyer le message",
    success: "Message envoyé avec succès !",
    close: "Fermer",
  },

  dashboard: {
    welcome: "Bon retour, ",
    overview: "Ma vue d’ensemble",
    summaryText: "Retrouvez ici un aperçu rapide de l’état de vos hébergements.",
    activeObjects: "Hébergement(s) en ligne",
    inReviewObjects: "Hébergement(s) en vérification",

    contact: "Mes coordonnées",
    editContact: "Modifier",

    settings: "Mes paramètres",
    subscription: "Abonnement",
    subscriptionActive: "Actif",
    password: "Mot de passe",
    changePassword: "Modifier le mot de passe",

    objects: "Mes hébergements",
    objectboxText: "Saisir disponibilités et prix",
    objectboxText2: "Modifier les informations de l’hébergement",
    objectbuttonText: "Gérer les hébergements",

    newObjectContainer: "Créer un nouvel hébergement",
    newObjectDescription: "Créez un nouvel hébergement ou continuez une saisie en cours.",
    continueDraft: "➜ Continuer la saisie",
    newObject: "+ Créer un nouvel hébergement",

    documents: "Documents",
    lastInvoice: "Dernière facture",
    openArchive: "Ouvrir l’archive",
  },

  contactEdit: {
    title: "Modifier les coordonnées",
    errorLoading: "Erreur lors du chargement des données.",
    errorSaving: "Erreur lors de l’enregistrement des données.",
    confirmLeave: "Voulez-vous enregistrer les modifications ?",
    salutation: "Civilité",
    selectSalutation: "Sélectionnez une civilité",
    company: "Entreprise",
    firstName: "Prénom",
    lastName: "Nom",
    street: "Rue",
    houseNumber: "Numéro",
    postalCode: "Code postal",
    town: "Ville",
    country: "Pays",
    selectCountry: "Sélectionnez un pays",
    phone: "Numéro de téléphone",
    cancel: "Annuler",
    save: "Enregistrer",
    requiredFields: "Veuillez remplir tous les champs obligatoires.",
  },

  registerUser: {
    title: "Coordonnées",
    verifiedMessage:
      "Votre adresse e-mail a été vérifiée avec succès. Veuillez maintenant saisir vos coordonnées.",

    salutation: "Civilité",
    selectSalutation: "Sélectionnez une civilité",
    company: "Entreprise (optionnel)",
    firstName: "Prénom",
    lastName: "Nom",
    street: "Rue",
    houseNumber: "Numéro",
    postalCode: "Code postal",
    town: "Ville",
    country: "Pays",
    selectCountry: "Sélectionnez un pays",

    phone: "Numéro de téléphone",
    phonePlaceholder: "Numéro de téléphone",
    phoneCodePlaceholder: "Indicatif",
    search: "Rechercher...",
    noResults: "Aucun résultat",

    terms: "J’accepte les",
    termsLink: "CGV",
    privacy: "J’accepte la",
    privacyLink: "politique de confidentialité",

    save: "Enregistrer les données",

    requiredFields: "Veuillez remplir tous les champs obligatoires.",
    acceptTerms: "Veuillez accepter les CGV et la politique de confidentialité.",
    loginFirst: "Veuillez d’abord vous connecter.",
    errorSaving: "Erreur lors de l’enregistrement des données !",
    errorLoading: "Erreur lors du chargement des données.",
  },

  password: {
    title: "Modifier le mot de passe",
    oldPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    confirmPassword: "Confirmer le nouveau mot de passe",

    cancel: "Annuler",
    save: "Enregistrer",

    errorInvalid: "Veuillez remplir correctement tous les champs.",
    errorGeneral: "Erreur lors de la modification du mot de passe.",
    success: "Mot de passe modifié avec succès.",
    confirmLeave: "Voulez-vous enregistrer les modifications ?",
  },

  impressum: {
    title: "Mentions légales",
    company: "glampingoase GmbH",
    addressLine1: "Breechliweg 3",
    addressLine2: "5102 Rupperswil",
    country: "Suisse",

    registryNumber: "Numéro du registre: CHE-432.303.436",
    registryCourt: "Registre du commerce du canton d’Argovie",

    emailLabel: "E-mail",
  },

  footer: {
    impressum: "Mentions légales",
  },

  objectList: {
    title: "Gérer disponibilités et prix",
    loading: "Chargement...",
    notConfirmed: "pas encore confirmé",
    editPrices: "Modifier les prix",
    editAvailability: "Modifier les disponibilités",
    noObjectsLine1: "Aucun hébergement créé pour le moment.",
    noObjectsLine2: "Souhaitez-vous en créer un maintenant ?",
    createObject: "Créer un nouvel hébergement",
    imageAlt: "Image de l’hébergement",
  },

  prices: {
    openCalendar: "Ouvrir le calendrier",
    datePlaceholder: "jj.mm.aaaa",
    object: "Hébergement",

    errorFetchCurrency: "Erreur lors du chargement de la devise",
    errorFetchObjects: "Erreur lors du chargement des hébergements",
    errorFetchObjectName: "Erreur lors du chargement du nom de l’hébergement",
    errorFetchSeasons: "Erreur lors du chargement des saisons",
    errorFetchSeasonsAlert: "Un problème est survenu lors du chargement des saisons.",
    errorNotLoggedIn: "Vous n’êtes pas connecté.",
    errorMissingFields: "Veuillez remplir tous les champs.",
    errorEndBeforeStart: "La date de fin ne peut pas être antérieure à la date de début.",
    errorOverlap: "Cette saison chevauche une saison existante.",

    errorSaveSeason: "Erreur lors de l’enregistrement de la saison",
    errorApiRequest: "Erreur lors de la requête API",
    errorSaveSeasonAlert: "Un problème est survenu lors de l’enregistrement de la saison.",

    confirmDeleteSeason: "Voulez-vous supprimer la saison",
    errorDeleteSeason: "Erreur lors de la suppression de la saison",
    errorDeleteSeasonAlert: "La saison n’a pas pu être supprimée.",

    errorFinishEditingFirst:
      "Veuillez terminer la modification en cours avant d’en ajouter une nouvelle.",

    tabPrices: "Prix",
    tabAdditionalCosts: "Frais supplémentaires",
    tabCurrency: "Devise",
    tabAvailability: "Disponibilité",
    tabObjectList: "Aperçu des hébergements",

    pricesFor: "Prix pour",

    hidePastSeasons: "Masquer les saisons passées",
    showPastSeasons: "Afficher les saisons passées",

    seasonName: "Nom de la saison",
    pricePerNight: "Prix par nuit en",

    saving: "Enregistrement...",
    cancel: "Annuler",
    addSeason: "+ Ajouter une saison",

    infoTitle: "Comment saisir les prix ?",

    infoText:
      "Pour chaque saison, définissez une période avec une date de début et une date de fin.\n\n" +
      "Vous pouvez donner à la saison le nom que vous souhaitez. Il sert uniquement à votre organisation interne et n’est pas affiché aux clients.\n\n" +
      "Le prix correspond au tarif par nuit. Assurez-vous que les périodes ne se chevauchent pas. Sinon, un message d’erreur apparaîtra.\n\n" +
      "Lorsque toutes les informations sont correctes, validez avec la coche verte. La saison sera enregistrée et vous pourrez en ajouter une nouvelle.\n\n" +
      "Une seule saison peut être modifiée à la fois, car chaque modification déclenche une vérification automatique des chevauchements.\n\n" +
      "Les saisons déjà enregistrées peuvent être modifiées via l’icône du crayon ou supprimées via l’icône de la corbeille. Ces actions ne sont possibles que si aucune autre saison n’est en cours de modification.\n\n" +
      "Vous pouvez afficher les saisons passées via le bouton 'Afficher les saisons passées'. Elles sont uniquement consultatives et ne peuvent plus être modifiées.",

    close: "Fermer",

    selectCurrencyTitle: "Sélectionner la devise",
    selectCurrencyText: "Veuillez choisir une devise avant d’ajouter des prix.",
    currencyRequired: "Veuillez d’abord sélectionner une devise.",

  },

  additionalCosts: {
    title: "Frais supplémentaires pour",
    object: "Hébergement",

    add: "Ajouter un frais supplémentaire",

    selectType: "Sélectionner un type de frais",
    selectUnit: "Sélectionner une unité",
    pricePlaceholder: "Prix en",

    saving: "Enregistrement...",
    cancel: "Annuler",

    finishEditingFirst:
      "Veuillez terminer la modification en cours avant d’ajouter un nouveau frais.",
    fillAllFields: "Veuillez remplir tous les champs.",
    confirmDelete: "Voulez-vous vraiment supprimer ce frais ?",

    errorLoadingTypes: "Erreur lors du chargement des types de frais",
    errorLoadingUnits: "Erreur lors du chargement des unités",
    errorLoadingCosts: "Erreur lors du chargement des frais",
    errorSaving: "Erreur lors de l’enregistrement",
    errorDeleting: "Erreur lors de la suppression",
  },

  currency: {
    title: "Devise pour",
    select: "Sélectionner une devise",
    saving: "Enregistrement...",
    save: "Enregistrer la devise",
    saved: "Devise enregistrée avec succès",
    errorLoadingCurrencies: "Erreur lors du chargement des devises disponibles",
    errorLoadingObjectCurrency: "Erreur lors du chargement de la devise de l’hébergement",
    errorLoadingObjectName: "Erreur lors du chargement du nom de l’hébergement",
    errorSaving: "Erreur lors de l’enregistrement de la devise",
    object: "Hébergement",
  },

availability: {
  settingsTitle: "Paramètres",
  modeTitle: "Mode de disponibilité",
  modeIcal: "Synchronisation iCal",
  modeManual: "Disponibilités manuelles",

  warningSwitch: "Changer de mode supprimera les disponibilités existantes. Continuer?",
  saved: "Paramètres enregistrés.",

  modalTitle: "Comment souhaitez-vous gérer vos disponibilités?",
  modalText: "Veuillez choisir une option. Vous pourrez la modifier à tout moment.",
  chooseIcal: "Synchronisation iCal",
  chooseManual: "Saisie manuelle",

  errorLoading: "Erreur lors du chargement des disponibilités.",
  tabsAriaLabel: "Onglets de disponibilité",

  tabSettings: "Paramètres",
  tabIcal: "Gérer iCal",
  tabManual: "Saisir les disponibilités",
  tabPrices: "Tarifs",
  tabObjectList: "Aperçu des objets"
},

availabilityManual: {
  editAvailability: "Modifier les disponibilités",
  loadingObject: "Chargement des informations de l’objet…",

  legendAvailable: "Disponible",
  legendDelete: "Supprimer",

  savedSuccess: "Disponibilités enregistrées avec succès!",
  savedPartialError: "Certaines disponibilités n’ont pas pu être enregistrées ou supprimées.",
  errorSaving: "Erreur lors de l’enregistrement.",
  errorNoObjectId: "Erreur : aucun ID d’objet trouvé."
},

availabilityIcal: {
  title: "Import iCal",
  loading: "Chargement…",

  placeholderUrl: "https://exemple.com/calendrier.ics",
  testPreview: "Tester l’aperçu",
  testing: "Test…",
  showSynced: "Afficher les données synchronisées",

  save: "Enregistrer",
  saving: "Enregistrement...",
  remove: "Supprimer",

  lastSync: "Dernière synchronisation",
  previewFailed: "Échec de l’aperçu",
  previewCalendar: "Aperçu (calendrier)",

  prev: "Précédent",
  next: "Suivant",

  errorLoading: "Erreur lors du chargement des données iCal.",
  errorNoUrl: "Aucun lien iCal fourni.",
  errorPreview: "Erreur lors de la récupération du lien.",
  errorInvalidUrl: "URL invalide.",
  errorSaving: "Échec de l’enregistrement.",
  errorRemove: "Échec de la suppression",
  removed: "Lien iCal supprimé",
  saved: "Lien iCal enregistré. Synchronisation lancée.",
  errorLoadSynced: "Erreur lors du chargement des données synchronisées.",
  errorNoObjectId: "Aucun ID d’objet trouvé."
},

  newObjectModal: {
    title: "Hébergement en cours trouvé",
    description:
      "Vous avez déjà commencé à créer un hébergement. Voulez-vous continuer ou recommencer en écrasant les données existantes ?",
    continue: "Continuer la saisie",
    startNew: "Recommencer",
  },

  object: {
    tabs: [
      "Données de base",
      "Pièces",
      "Équipements / Environs",
      "Occupation",
      "Description",
      "Images",
      "Soumettre"
    ],

    step1: {
      title: "Étape 1 : Informations générales",
      fields: {
        name: "Nom de l’hébergement",
        street: "Rue",
        house_number: "Numéro",
        postal_code: "Code postal",
        city: "Ville",
        object_type: "Type d’hébergement",
        country: "Pays",
        region: "Région",
        licence_number: "Numéro de licence",
      },

      select: {
        choose: "Sélectionner",
      },

      map: {
        info: "Le marqueur est placé automatiquement selon l’adresse saisie. Vous pouvez le déplacer si nécessaire.",
        reset: "Réinitialiser le marqueur à l’adresse saisie",
        load_error: "Impossible de charger la carte.",
        loading: "Chargement de la carte...",
      },

      geocode: {
        failed: "Échec du géocodage.",
        missing_fields:
          "Veuillez remplir tous les champs de l’adresse et vérifier que l’API Google Maps est chargée.",
      },
    },
      step2: {
        title: "Étape 2 : Pièces & équipements",
        addRoom: "Ajouter une pièce",
        roomCountTitle: "Combien de pièces comporte votre logement ?",
        roomCountDescription: "Indiquez le nombre pour chaque type de pièce. Vous pourrez ensuite les modifier individuellement.",
        roomCountSharedHint: "Les pièces partagées comme la salle de bain et la cuisine comptent également.",
        addAllRooms: "Ajouter toutes les pièces",
        roomType: "Type de pièce",
        amount: "Quantité",
        select: "Veuillez choisir",
        usage: "Utilisation",
        private: "Usage privé",
        shared: "Usage partagé",
        onlyOneAllowed: "seulement 1 autorisé",

        // Beds
        beds: "Lits",
        addBed: "Ajouter un lit",
        bedType: "Type de lit",
        size: "Taille",
        sizeWidth: "Largeur (cm)",
        sizeLength: "Longueur (cm)",
        sizeOptional: "Optionnel",
      },

    step3: {
        title: "Étape 3 : Équipements et environs",
        general: "Équipements généraux",
        outdoor: "Équipements extérieurs",
        environmentAmenities: "Équipements des environs",
        environmentCards: "Environs",
        errorLoading: "Erreur lors du chargement des équipements."
      },
      step4: {
        title: "Étape 4 : Occupation et options de contact",

        maxOccupancy: "Occupation maximale",
        maxPets: "Nombre maximum d’animaux",
        minNights: "Durée minimale du séjour",

        selectPlaceholder: "Veuillez choisir",

        arrivalDays: "Jours d’arrivée",

        earliestCheckin: "Arrivée la plus tôt",
        latestCheckout: "Départ le plus tard",

        rules: "Règles",
        partyAllowed: "Fêtes autorisées",
        smokingAllowed: "Fumer autorisé",
        yes: "Oui",
        no: "Non",

        contactOptions: "Options de contact",
        contactHow: "Comment les invités doivent-ils vous contacter ?",
        contactBoth: "Les deux",
        contactWebsite: "Site web",
        contactWebsitePlaceholder: "https://example.com",
        contactEmail: "E-mail pour le formulaire de contact",

        invalidEmail: "Veuillez entrer une adresse e-mail valide.",
        errorLoadingArrivalDays: "Erreur lors du chargement des jours d’arrivée."
      },
      step5: {
        title: "Étape 5 : Description du logement",
        activitiesTitle: "Activités à proximité",
        activitiesPlaceholder: "Décrivez ce que les voyageurs peuvent trouver près de votre logement.",
        descriptionTitle: "Description du logement",
        descriptionPlaceholder: "Veuillez saisir un texte pertinent décrivant bien le logement."
      },
      step6: {
        title: "Étape 6 : Téléchargement des images",

        titleImage: "Image principale",
        additionalImages: "Images supplémentaires (max. 20)",

        selectOrDragTitle: "Sélectionnez ou glissez votre image principale ici",
        dragTitleHere: "Glissez votre image principale ici",

        selectOrDragAdditional: "Sélectionnez des fichiers ou glissez-les ici",
        dragAdditionalHere: "Glissez ici des images supplémentaires",

        uploaded: "Image téléchargée",
        uploadedCount: "{n} image(s) téléchargée(s)",

        errorMinSize: "L’image doit mesurer au moins {w}x{h} pixels.",
        errorInvalidFormat: "Format d’image invalide."
      },
      step7: {
        title: "Étape 7 : Finalisation & choix de l’abonnement",
        intro: "Presque terminé ! Choisissez votre abonnement et vérifiez que toutes les étapes sont complètes.",

        subscriptionTitle: "Choisir un abonnement",

        freeTitle: "Free",
        freePrice: "Gratuit",
        freeDescription: "Texte fictif. La description va ici.",

        monthlyTitle: "Mensuel",
        monthlyPrice: "2 CHF / mois",
        monthlyDescription: "Texte fictif. La description va ici.",

        yearlyTitle: "Annuel",
        yearlyPrice: "20 CHF / an",
        yearlyDescription: "Texte fictif. La description va ici.",

        overviewTitle: "Aperçu de vos informations",
        fix: "Compléter",

        overviewItems: [
          { step: 1, title: "Données de base" },
          { step: 2, title: "Pièces"},
          { step: 3, title: "Équipements / Environs" },
          { step: 4, title: "Occupation"},
          { step: 5, title: "Description" },
          { step: 6, title: "Images" }
        ],

        errorUnknown: "Erreur inconnue.",
        errorGeneral: "Une erreur s’est produite."
      }

  },
};
